import React, { useEffect, useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Badge } from "primereact/badge";
import { IModal } from "./PrimeVendorAllocation";
import { Fetch } from "../../shared/Fetch";
import AllocationDialog from "./AllocationDialog";

interface IProps {
  setModal: (modal: IModal) => void;
  permissions: IPermissionProps;
  reload: boolean;
  setReload: (is: boolean) => void;
  toast: any;
}

export interface IPrimeVendorAllocation {
  id: number;
  from_Company_ID: number;
  from_Company_Name: string;
  allocated_Companies: Array<{ company_ID: number; company_Name: string }>;
}

export const EmptyPrimeVendorAllocation: IPrimeVendorAllocation = {
  id: 0,
  from_Company_ID: 0,
  from_Company_Name: "",
  allocated_Companies: [],
};

const Table = (props: IProps) => {
  const [tableData, setTableData] = useState<Array<IPrimeVendorAllocation>>([]);
  const [loading, setLoading] = useState(false);
  const [allocDialog, setAllocDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<IPrimeVendorAllocation | null>(null);
  const dt = useRef<any>(null);

  const loadTableData = async () => {
    setLoading(true);
    try {
      const response = await Fetch("PV_Allocation_Mast/getpvallocation", "GET", null, "", props.toast);
      if (response && response.ok) {
        const data: Array<IPrimeVendorAllocation> = await response.json();
        setTableData(data);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTableData();
  }, [props.reload]);

  const openNew = () => props.setModal({ open: true, singleData: EmptyPrimeVendorAllocation });
  const openEdit = (rowData: IPrimeVendorAllocation) => props.setModal({ open: true, singleData: rowData });

  const allocationCountBody = (rowData: IPrimeVendorAllocation) => (
    <span
      onClick={() => {
        setSelectedRow(rowData);
        setAllocDialog(true);
      }}
      style={{ cursor: "pointer" }}
    >
      <Badge value={rowData.allocated_Companies.length} severity="info" style={{ fontSize: "0.85rem", textDecoration: "underline" }} />
    </span>
  );

  const actionBody = (rowData: IPrimeVendorAllocation) => <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)} />;

  const leftToolbarTemplate = () => (
    <div className="my-2">
      <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
    </div>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Prime Vendor Allocation</h5>
    </div>
  );

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} />
      <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" value={tableData} resizableColumns showGridlines columnResizeMode="expand" emptyMessage="No records found." header={header} loading={loading}>
        <Column field="from_Company_Name" header="Req From Company" />
        <Column body={allocationCountBody} header="Allocation to Companies" style={{ textAlign: "center", width: "180px" }} />
        <Column body={actionBody} header="Action" style={{ width: "80px" }} />
      </DataTable>
      <AllocationDialog open={allocDialog} onHide={() => setAllocDialog(false)} rowData={selectedRow} toast={props.toast} reload={props.reload} setReload={props.setReload} />
    </>
  );
};
export default Table;
